export default __webpack_public_path__ + "static/media/secret-hitler.11211aea.png";